import { getCountry, getLang } from "../../../router/scripts/params";

export function getDateFormatted(dateString?: string): string {
  if (dateString && dateString !== "0000-00-00") {
    return new Intl.DateTimeFormat(`${getLang()}-${getCountry()}`).format(new Date(dateString));
  }
  return "";
}
